import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { api } from "../lib/api";

export function Layout() {
  const [email, setEmail] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    api.me().then((m) => setEmail(m.email)).catch(() => setEmail(null));
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-white border-b border-neutral-200">
        <div className="max-w-6xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-semibold">
            <span className="inline-block w-2 h-2 rounded-full bg-red-500" />
            Windhund 365 · Video Manager
          </Link>
          <nav className="flex items-center gap-1 text-sm">
            <NavLink
              to="/"
              end
              className={({ isActive }) =>
                `px-3 py-1.5 rounded-md ${isActive ? "bg-neutral-900 text-white" : "text-neutral-700 hover:bg-neutral-100"}`
              }
            >
              Library
            </NavLink>
            <NavLink
              to="/upload"
              className={({ isActive }) =>
                `px-3 py-1.5 rounded-md ${isActive ? "bg-neutral-900 text-white" : "text-neutral-700 hover:bg-neutral-100"}`
              }
            >
              Upload
            </NavLink>
            <NavLink
              to="/settings"
              className={({ isActive }) =>
                `px-3 py-1.5 rounded-md ${isActive ? "bg-neutral-900 text-white" : "text-neutral-700 hover:bg-neutral-100"}`
              }
            >
              Settings
            </NavLink>
            {email && (
              <span className="ml-3 text-xs text-neutral-500 hidden sm:inline" title="From Cloudflare Access">
                {email}
              </span>
            )}
          </nav>
        </div>
      </header>
      <main key={location.pathname} className="flex-1 max-w-6xl w-full mx-auto px-6 py-8">
        <Outlet />
      </main>
      <footer className="text-center text-xs text-neutral-400 py-6">
        Videos hosted on Cloudflare Stream · Access restricted to @windhund.com
      </footer>
    </div>
  );
}
